import api from "./Api";

class DistribuidorMasterService {
  GetDistribuidorMaster(payload) {
    return api.get("/v1/distribuidormaster/" + payload).then((response) => {
      return response.data;
    });
  }

  PostDistribuidorMaster(payload) {
    return api.post("/v1/distribuidormaster/", payload).then((response) => {
      return response.data;
    });
  }

  PutDistribuidorMaster(payload) {
    return api.put("/v1/distribuidormaster/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteDistribuidorMaster(payload) {
    return api.delete("/v1/distribuidormaster/" + payload).then((response) => {
      return response.data;
    });
  }

  GetDistribuidorMasterOData(payload) {
    return api.get("/OData/distribuidormaster" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new DistribuidorMasterService();
